import { PropsWithChildren, useEffect } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { useGetIsLoggedIn } from 'hooks';
import { routeNames, routes } from 'routes';

/**
 * Redirects to the unlock page whenever the current route requires
 * authentication and the user isn't logged in.
 */
export const RequireAuthWrapper = ({ children }: PropsWithChildren) => {
  const isLoggedIn = useGetIsLoggedIn();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const currentRoute = routes.find((route) => matchPath(route.path, pathname));
  const requiresAuth = Boolean(currentRoute?.authenticatedRoute);

  useEffect(() => {
    if (!isLoggedIn && requiresAuth) {
      navigate(`${routeNames.unlock}${search}`);
    }
  }, [isLoggedIn, requiresAuth]);

  return <>{children}</>;
};
